import * as React from "react";
import Modal from "@mui/material/Modal";
import {
  ModalHeader,
  ModalTitle,
  StyledBox,
  StyledBoxFlex,
  StyledBoxLi,
  StyledLiTop,
  StyledTypographyLiTopic,
  StyledUl,
} from "./style";

import vectorIcon from "../../../assets/images/vector-group.png";
import theme from "../../../theme";
import CrossIcon from "../../../assets/Icons/CrossIcon";

export default function GroupCartGuidelines({ open, handleClose }) {
  return (
    <Modal open={open} onClose={handleClose}>
      <StyledBox>
        <ModalHeader>
          <StyledBoxFlex>
            <img src={vectorIcon} alt="vectorIcon" loading="lazy" />
            <ModalTitle>Group Cart Guidelines</ModalTitle>
          </StyledBoxFlex>
          <CrossIcon
            color={theme.palette.custom.warning}
            onClick={handleClose}
          />
        </ModalHeader>

        <StyledBoxLi>
          <StyledUl>
            <StyledLiTop>
              <StyledTypographyLiTopic>
                Each member gets their own sub-cart under the group
              </StyledTypographyLiTopic>
            </StyledLiTop>
            <StyledLiTop>
              <StyledTypographyLiTopic>
                You&apos;re responsible for your own order details and
                preferences.
              </StyledTypographyLiTopic>
            </StyledLiTop>
            <StyledLiTop>
              <StyledTypographyLiTopic>
                All members must complete their cart within the deadline.
              </StyledTypographyLiTopic>
            </StyledLiTop>
            <StyledLiTop>
              <StyledTypographyLiTopic>
                Costs will be split automatically based on individual
                items&apos; weight accumulated in the package.
              </StyledTypographyLiTopic>
            </StyledLiTop>
            <StyledLiTop>
              <StyledTypographyLiTopic>
                Shipping box weight will be split equally depends on the number
                of members
              </StyledTypographyLiTopic>
            </StyledLiTop>
            <StyledLiTop>
              <StyledTypographyLiTopic>
                Choose to pay separately or allow the main user to pay for all.
              </StyledTypographyLiTopic>
            </StyledLiTop>
            <StyledLiTop>
              <StyledTypographyLiTopic>
                Group orders are shipped together-delays from one may affect
                all.
              </StyledTypographyLiTopic>
            </StyledLiTop>
            <StyledLiTop>
              <StyledTypographyLiTopic>
                No edits or cancellations after payment without support
                approval.
              </StyledTypographyLiTopic>
            </StyledLiTop>
            <StyledLiTop>
              <StyledTypographyLiTopic>
                Native Shipper isn&apos;t responsible for disputes
              </StyledTypographyLiTopic>
            </StyledLiTop>
            <StyledLiTop>
              <StyledTypographyLiTopic>
                Customs may apply individually depending on item type.
              </StyledTypographyLiTopic>
            </StyledLiTop>
            <StyledLiTop>
              <StyledTypographyLiTopic>
                Joining the cart means you accept these terms.
              </StyledTypographyLiTopic>
            </StyledLiTop>
            <StyledLiTop>
              <StyledTypographyLiTopic>
                Packages will be shipped to one address
              </StyledTypographyLiTopic>
            </StyledLiTop>
          </StyledUl>
        </StyledBoxLi>
      </StyledBox>
    </Modal>
  );
}
